import styled, { css } from 'styled-components';

export const AppLayout = styled.div`
  display: grid;
  grid-auto-flow: row;
  min-height: 100vh;
  max-width: 3000px;
  margin: 0 auto;
  flex: 1;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  flex: auto;
  border-radius: 0px;
  overflow-y: auto;
  position: relative;
  width: 95.5%;
  margin: auto;
  ${(props) =>
    props.hideNavbar
      ? css`
          margin-top: 0px;
          margin-bottom: 0px;
        `
      : css`
          margin-top: 90px;
          margin-bottom: 40px;
        `}
`;
